import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const VARIANTS = ["view", "edit", "delete", "restore", "neutral"];

let tooltipCounter = 0;

export default function ActionIconButton({
  icon,
  label,
  variant = "neutral",
  onClick,
  loading = false,
  onImage = false,
  className = "",
  type = "button",
}) {
  const [tooltipId] = React.useState(() => `np-action-tip-${++tooltipCounter}`);
  const safeVariant = VARIANTS.includes(variant) ? variant : "neutral";
  const classes = [
    "np-action-btn",
    `np-action-btn--${safeVariant}`,
    onImage ? "np-action-btn--on-image" : "",
    loading ? "np-action-btn--loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <OverlayTrigger
      placement="top"
      trigger={["hover", "focus"]}
      overlay={
        <Tooltip id={tooltipId} className="np-action-tooltip">
          {label}
        </Tooltip>
      }
    >
      <button
        type={type}
        className={classes}
        aria-label={label}
        aria-busy={loading || undefined}
        onClick={loading ? undefined : onClick}
      >
        {icon}
      </button>
    </OverlayTrigger>
  );
}
